export const aiResponses = {

  sectorSelected: [
    sector => `Got it — **${sector}**.

This is one of the more operationally complex environments to monitor, which is exactly why AI-driven visibility makes such a difference here. Things like workflow bottlenecks, compliance gaps, and real-time anomalies tend to slip through manual oversight.

I'll tailor the use cases to what matters most in **${sector}** operations. Let's pick what you want the system to watch for.`,

    sector => `**${sector}** — solid choice.

Operationally, this sector generates a lot of signal: movement patterns, task compliance, safety behaviour, process adherence. Most of it goes untracked without the right tooling.

Let's define which areas you want the AI to focus on.`,

    sector => `Noted — **${sector}**.

There's a lot of opportunity here. AI-assisted monitoring in this environment typically surfaces issues that only become visible in hindsight otherwise — staffing gaps, safety deviations, process inefficiencies.

Next step: let's configure the specific use cases you want enabled.`,

    sector => `**${sector}**, perfect.

Real-time operational visibility in this space can meaningfully reduce response times and surface patterns that manual review misses. The system will continuously analyse your camera feeds for the signals that matter most.

Let's select the operational use cases to activate.`,
  ],

  useCasesSelected: [
    cases => `Great — you've selected **${cases.length} use case${cases.length > 1 ? 's' : ''}**: ${cases.map(c => `**${c}**`).join(', ')}.

Each of these will be continuously monitored across your camera feeds in real time. The system will generate alerts, trend reports, and anomaly flags specific to these areas.

Let me now collect a few details to complete your account setup.`,

    cases => `Nice configuration. With **${cases.join(', ')}** enabled, your control room will have full visibility into the operational signals that matter most for your environment.

The AI will learn baseline patterns over time and flag deviations — giving your team actionable insights rather than raw footage.

Let's move on to account setup.`,

    cases => `This is a strong setup. **${cases.join(', ')}** covers both situational awareness and operational intelligence — you'll be able to detect issues early and track trends over time.

Just a few more details and your dashboard will be ready.`,

    cases => `Excellent selections. **${cases.join(', ')}** — these use cases will give your team a meaningful operational edge.

The system will run continuous analysis across your feeds and surface relevant events automatically.

Now let's finish your account setup.`,
  ],

  configComplete: [
    () => `Your operational configuration looks solid — I have everything I need to build your control room.

Before I activate it, I just need a few account details. This will only take a minute.`,

    () => `Configuration complete. The system now knows exactly what to monitor, where, and how many feeds to process.

Let's quickly set up your account so you can access the dashboard.`,

    () => `That's all I need for the operational side. Your AI control room is taking shape.

One last step — let's create your account so you can log in and start using it.`,

    () => `Everything looks good on the configuration side.

Let's move into account setup — just a handful of quick questions and you'll be ready to go.`,
  ],

  registrationStart: [
    () => `Before I launch your workspace, I need a few quick details to create your account.`,

    () => `You're almost there. Let's set up your account so you can access the dashboard.`,

    () => `Just a few details and your operational control room will be live.`,

    () => `Let's quickly complete your account setup to activate the platform.`,
  ],

  userAcknowledgement: [
    () => `Noted — thank you for sharing that.`,
    () => `That's been recorded. Appreciate you providing the details.`,
    () => `Understood. We'll factor that into your configuration.`,
    () => `Thank you. Moving on to the next step.`,
    () => `Details captured. Let's continue.`,
  ],
};


export function getRandomResponse(list, param) {
  const fn = list[Math.floor(Math.random() * list.length)];
  return fn(param);
}